import React from 'react';
import { AtSign } from 'lucide-react';
import { handlePopupClick } from '../lib/openCenteredPopup';
import { SOVEREIGN_SOCIAL } from '../lib/sovereignSocial';

/**
 * SovereignSocialConnect — compact body "Connect" block.
 * Renders all 10 Sovereign Social Matrix anchors as small pill tiles.
 * Placed above the Unified Federation Hub, next to the Evolutionary Nudge.
 * All links open via centered 50%×50% popup (handlePopupClick).
 */
export default function SovereignSocialConnect() {
  return (
    <section
      data-testid="sovereign-social-connect"
      aria-label="Sovereign Social Matrix — Connect with the Federation"
      className="mx-auto max-w-5xl px-4 py-8 border-y border-white/10 bg-gradient-to-b from-black via-slate-950/60 to-black"
    >
      <div className="flex items-center gap-3 mb-4">
        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-slate-500/20 border border-slate-300/50">
          <AtSign className="w-3.5 h-3.5 text-slate-200" />
        </span>
        <h3 className="text-[10px] font-mono uppercase tracking-[0.32em] text-slate-200/90">
          Connect · Sovereign Social Matrix
        </h3>
        <span className="h-px bg-slate-300/20 flex-1" />
        <span className="text-[9px] font-mono uppercase tracking-[0.22em] text-white/40">
          10 anchors
        </span>
      </div>

      <ul
        data-testid="sovereign-social-connect-list"
        className="flex flex-wrap gap-2"
      >
        {SOVEREIGN_SOCIAL.map((s) => (
          <li key={s.id}>
            <a
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handlePopupClick(s.href)}
              data-testid={`connect-${s.id}`}
              title={`${s.platform} — ${s.name} · opens in centered popup`}
              className="group inline-flex items-center gap-2 px-3 py-2 rounded-full border border-white/10 bg-white/5 hover:bg-white/10 hover:border-white/25 transition-all"
            >
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full bg-gradient-to-br ${s.ringFrom} ${s.ringTo} p-[1.5px]`}
              >
                <span className="inline-flex items-center justify-center w-full h-full rounded-full bg-black text-white font-serif text-[11px] font-bold">
                  {s.initial}
                </span>
              </span>
              <span className="flex flex-col leading-tight">
                <span className="text-[10px] font-semibold text-white">
                  {s.name}
                </span>
                <span className="text-[8px] font-mono uppercase tracking-[0.18em] text-white/50">
                  {s.platform}
                </span>
              </span>
            </a>
          </li>
        ))}
      </ul>

      <p className="mt-3 text-[9px] font-mono uppercase tracking-[0.2em] text-white/35">
        Centered popup · Federation-verified anchors · No external CDNs
      </p>
    </section>
  );
}
